// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"employee_promotion_manager__3yETf","promotion_manager_title":"employee_promotion_manager_title__1b9Bo","card":"employee_card__3EPrK"};